import { React, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import OtherService from "../../services/Other";
import {
  getColor,
  getIcon,
  formatNumber,
} from "../../constants/commonFunction";
import { addContractorCount } from "../../redux/slices/currentUserSlice";
import BigBox from "../BigBox.js";
import Box from "../Box.js";

const ApprovalAnalytics = () => {
  const dispatch = useDispatch();
  const [hierName, setHiername] = useState(null);
  const [loyaltyData, setLoyaltyData] = useState([]);
  const [saleData, setSaleData] = useState([]);
  const [businessTimeframe, setBusinessTimeframe] = useState("MTD");
  const [approvalAnalytics, setApprovalAnalytics] = useState([]);
  const [loading, setLoading] = useState(false);

  const brandId = JSON.parse(localStorage.getItem("currentBrand")).id;

  const trigger = async () => {
    const hierDesc = JSON.parse(localStorage.getItem("userData")).hierCode;
    setHiername(hierDesc);
    if (hierDesc == "Contractor") {
    }
    if (hierDesc == "TSE") {
      getApprovalAnalytics("MTD");
    }
  };

  useEffect(() => {
    setLoyaltyData([]);
    trigger();
  }, [brandId]);

  const getApprovalAnalytics = async (option) => {
    try {
      setLoading(true);
      const payload = {
        business_timeframe: option,
        hierarchies: [20],
      };
      const res = await OtherService.getTseApprovalAnalytics(payload);
      if (res.success === true) {
        const result = res?.response;
        const arr = [];
        for (let [key, value] of Object.entries(result)) {
          if (key !== "message") {
            arr.push({
              color: getColor(key),
              value: value,
              label: String(key),
            });
          }
        }
        setApprovalAnalytics(arr);
      }
    } catch (err) {
      console.error("TSE Analytics report api error");
    } finally {
      setLoading(false);
    }
  };

  const changeAnalyticsTimeFrame = async (option) => {
    setBusinessTimeframe(option);
    try {
      await getApprovalAnalytics(option);
    } catch (err) {
      console.error("Error while changing analytics timeframe:");
    }
  };

  return (
    <>
      <BigBox
        header="Approval Analytics"
        options={["MTD", "YTD"]}
        selectedOption={businessTimeframe}
        onChange={changeAnalyticsTimeFrame}
      >
        {loading ? (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              color: "#000",
              maxHeight: "112px",
              minWidth: "202px",
              minHeight: "112px",
            }}
          >
            <p className="text-[16px] text-slate-600 font-medium">Loading...</p>
          </div>
        ) : approvalAnalytics?.length > 0 ? (
          approvalAnalytics.map((item, index) => {
            return (
              <Box bgColor={item?.color} key={index}>
                <div className="flex flex-col items-center    justify-center h-full text-center">
                  <p className="text-xl font-bold text-gray-900 leading-snug">
                    {item?.value}
                  </p>
                  <p className="text-sm text-gray-700 mt-1">
                    {item?.label?.charAt(0).toUpperCase() +
                      item?.label?.slice(1)}{" "}
                    Entry
                  </p>
                </div>
              </Box>
            );
          })
        ) : (
          <div
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              color: "#000",
              maxHeight: "112px",
              minWidth: "202px",
              minHeight: "112px",
            }}
          >
            <p className="text-[18px] font-bold text-slate-600 text-center">
              No data found !!!
            </p>
          </div>
        )}
      </BigBox>
    </>
  );
};

export default ApprovalAnalytics;
